/* globals angular */
(function(){
  'use strict';

  var reverseForm = {
    template: require('./reverse-form.html'),
    controller: 'ReverseFormCtrl',
    controllerAs: 'vm'
  };

  angular
    .module('mandaeApp')
    .component('reverseForm', reverseForm)
    .config(['$qProvider', '$stateProvider', function($qProvider, $stateProvider) {
      $qProvider.errorOnUnhandledRejections(false);
      $stateProvider
        .state('reverse-form', {
          url: '/reversas/formulario',
          component: 'reverseForm',
          params: {
            originalPackageId: null,
            originalOrderId: null
          }
        });
    }]);

}());
